/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { Add, ArrowDropDown } from "@mui/icons-material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import { addDays, format } from 'date-fns';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useRef, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { getCurrencyCode } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getFileType } from "utils/generic";
import { convertToTitleCase, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { SaveRCTI, UpdateRCTI, getDefaultRCTIDueDate, getItemsForInvoice, getRCTIDetailsByID, getSupplierForRCTI } from "utils/invoiceAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { AllKeysHaveValue } from "utils/generic";
import useTableStyles from "styles/customStyleItemTable";
import { calculateAmounts } from "utils/generic";
import { calculatePrice } from "utils/generic";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { paymentTermsOptions } from "utils/generic";

import RouteModal from "components/displayModel/routeModal";

const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const SCREEN_NAME = "RCTI";
let SCREEN_RIGHT;

function handleApiResponse({
  isUpdate,
  values,
  setOpen,
  showResMsg,
  navigate,
  handleSoftDismisal,
  setShowBillingModal,
  dispatch,
  redirectToOutside,
  RCTI_ID,
}) {

  const apiFunction = isUpdate ? UpdateRCTI : SaveRCTI;

  apiFunction(values, (data) => {
    if (data?.Result_Status) {
      setOpen(false);
      // showResMsg(data.Result_Message, 2000, data.Result_Status,);
      let targetRoute;
      if (redirectToOutside === 'redirectToItemWhenSave') {
        navigate(`/items/addItems?new=rcti&id=${data.Result_Output._id}`)
      }
      else if (redirectToOutside === 'redirectToEditItemWhenSave') {
        let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit")
        console.log("ItemIdForItemEdit", ItemIdForItemEdit)
        sessionStorage.removeItem("ItemIdForItemEdit");
        navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?source=rcti&id=${data.Result_Output._id || ''}`);

      }

      else {
        showResMsg(data.Result_Message, 2000, data.Result_Status, navigate, '/rcti');
        // let targetRoute = '/rcti';
        // let targetRoute = `/rcti/edit/${data.Result_Output._id}`;
        // navigate(targetRoute);
      }
      // if (isUpdate) {
      //   // targetRoute = (data.Result_Output?.redirect) ? '/rcti' : '';
      //   targetRoute = '/rcti';

      // } else {
      //   //when save api run below code will excute 
      //   targetRoute = '/rcti/edit/' + data.Result_Output._id;

      // }
      // navigate(targetRoute);
    } else if (data.Result_Message === "ALREADY_EXIST_PO") {
      handleSoftDismisal();
    } else {
      if (data.Result_Output === "NO AVAILABLE CREDITS") {
        setShowBillingModal(true);
      }
      showResMsg(data.Result_Message, 2000, data.Result_Status);
    }
  }, dispatch);
}

function RCTI() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const customStyles = useTableStyles();
  const { id: RCTI_ID } = useParams();
  const showAddNewSupplier = RCTI_ID === undefined;
  let type = new URLSearchParams(window.location.search).get('type');
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
  const [invoiceNoErr, setInvoiceNoErr] = useState(false);
  const [contactNameErr, setContactNameErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactDetails, setContactDetails] = useState([]);
  const [showInvoicePaymentLink, setShowInvoicePaymentLink] = useState(false);
  const [itemsDetails, setItemsDetails] = useState([]);
  const [masterItemDetails, setMasterItemDetails] = useState([]);
  const [screenName, setScreenName] = useState("Add New RCTI");
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [showItemAndDocumentSection, setShowItemAndDocumentSection] = useState(false);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [selectedFileType, setSelectedFileType] = useState('');
  const [fileError, setFileError] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [fieldsVisible, setFieldsVisible] = useState(false);
  const [openPop, setOpenPop] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
      discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: "",
    },
  ]);
  //Used for Modal Email Template 
  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "RCTI",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });
  const [values, setValues] = useState({
    token: token,
    businessUserID: loginDetails?.businessUserID,
    userID: loginDetails?._id,
    rctiID: undefined,
    rctiNumber: 'Auto Generated',
    supplierID: '',
    purchaseOrderNumber: '',
    rctiDate: new Date(),
    dueDate: new Date(),
    dueUpto: "Same Day",
    rctiStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
    documentName: "",

    paymentDate: new Date(),
    paymentMode: undefined,
    paymentTransactionID: undefined,
    paymentAmount: undefined,
    sendEmailFlag: false,
  });
  const [quoDocuments, setDocuments] = useState([]);
  const [currencyCode, setCurrencyCode] = useState("");
  const [paymentModeErr, setPaymentModeErr] = useState(false);
  const [paymentTransactionIDErr, setPaymentTransactionIDErr] = useState(false);
  const [showSaveAndSendEmailBtn, setShowSaveAndSendEmailBtn] = useState(true);
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false);

  const itemRowValuesRef = useRef(itemRowValues);

  useEffect(() => {
    var element = document.getElementsByTagName('fieldset');
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    var disabledval = document.querySelectorAll('.Mui-disabled');
    var dropicons = document.querySelectorAll('.MuiInputBase-root');
    for (let i = 0; i < element.length; i++) {

      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
    }

    for (let i = 0; i < disabledval.length; i++) {
      var usevalue = disabledval[i].getElementsByTagName('input');

      if (usevalue.length > 0) {
        if (darkMode) {
          usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

        } else {
          usevalue[0].style.removeProperty("-webkit-text-fill-color");
        }
      }
    }


    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName('svg');
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill:");
        }
      }
    }

  }, [itemRowValues, expanded, fieldsVisible])

  var disabledval = document.querySelectorAll('.Mui-disabled');
  for (let i = 0; i < disabledval.length; i++) {
    var usevalue = disabledval[i].getElementsByTagName('input');

    if (usevalue.length > 0) {
      if (darkMode) {
        usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

      } else {
        usevalue[0].style.removeProperty("-webkit-text-fill-color");
      }
    }
  }



  useEffect(() => {
    let HoldQuotationData = JSON.parse(sessionStorage.getItem('HoldQuotationData'));
    console.log("HoldQuotationData", HoldQuotationData);

    if (HoldQuotationData) {
      setValues((prevValues) => ({
        ...prevValues,

        businessUserID: HoldQuotationData.businessUserID || "",
        supplierID: HoldQuotationData.supplierID || "",
        rctiDate: HoldQuotationData.rctiDate || "",
        dueUpto: HoldQuotationData.dueUpto || "",
        dueDate: HoldQuotationData.dueDate || "",
        // quotationNumber: HoldQuotationData.quotationNumber || "",
        finalAmount: HoldQuotationData.finalAmount || "0.00",
        totalAmount: HoldQuotationData.totalAmount || "0.00",
        totalDiscountAmount: HoldQuotationData.totalDiscountAmount || "0.00",
        totalGSTAmount: HoldQuotationData.totalGSTAmount || "0.00",
        name: HoldQuotationData.name || "",
        gstType: HoldQuotationData.gstType || "Inclusive",
        rctiStatus: HoldQuotationData.rctiStatus || "Pending",
        purchaseOrderNumber: HoldQuotationData.purchaseOrderNumber || "",
        paymentInstruction: HoldQuotationData.paymentInstruction || "",
      }));

    }


    if (JSON.stringify(itemRowValues) !== JSON.stringify(itemRowValuesRef.current)) {
      itemRowValuesRef.current = itemRowValues;
      calculateDiscountAmount(itemRowValues);
    }
    addNewRowInList(itemRowValues);
    const filtered = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== undefined);
    if (filtered.length > 0) {
      setShowSendEmailBtn(filtered.every(row => row.itemID && row.itemPrice && row.itemQuantity))
    } else {
      setShowSendEmailBtn(false);
    }
  }, [itemRowValues]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setScreenName(RCTI_ID ? (type !== "clone" ? "Edit RCTI" : "Clone RCTI") : "Add New RCTI");
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));

        await Promise.all([
          getRight(),
          LoadInitialData(),
          // fetchDefaultRCTIDueDate(),
          fetchCurrencyValue(),
        ])
        await FetchQuotationDetailsByID();

      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, [dispatch, RCTI_ID]);

  useEffect(() => {
    const isItemSelected = itemRowValues.every(
      row => row.itemID && row.itemPrice && row.itemQuantity
    );
    setShowSaveAndSendEmailBtn(!isItemSelected);

  }, [itemRowValues]);


  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    if (SCREEN_RIGHT !== "Full Access") {
      showResMsg(genericMessage.notPermission, 2000, false);
      navigate("/rcti");
    }
  }
  const LoadInitialData = async () => {
    getSupplierForRCTI(values, data => {
      if (data.Result_Output.length > 0) {
        setContactDetails(data.Result_Output);
      }
    }, dispatch)
  };
  let fetchCurrencyValue = async () => {
    await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
      if (data.Result_Status) {
        setCurrencyCode(data.Result_Output)
      }
    }), dispatch);
  }

  const FetchQuotationDetailsByID = async () => {

    try {
      // Fetch items for quotation
      const itemsPromise = new Promise((resolve, reject) => {
        getItemsForInvoice(values, data => {
          if (data.Result_Output.length > 0) {
            setItemsDetails(data.Result_Output);
            setMasterItemDetails(data.Result_Output);
            resolve();
          } else {
            reject(new Error("No items found for quotation"));
          }
        }, dispatch);
      });
      let detailsPromise;
      if (RCTI_ID) {
        values.rctiID = RCTI_ID;
        // Fetch quotation details
        detailsPromise = new Promise((resolve, reject) => {
          getRCTIDetailsByID(values, (data) => {

            let result = data.Result_Output[0];
            if (data.Result_Output.length > 0) {
              setValues({ ...values, ...result, });
              if (result.items?.length > 0) {
                setItemRowValues(result.items);
              }
              if (result.documents?.length > 0) {
                setDocuments(result.documents);
              }

              // setShowItemAndDocumentSection(true);
              setShowInvoicePaymentLink(data.Result_Output[0].showPaymentSection);
              resolve(); // Resolve the promise once data is fetched
            } else {
              reject(new Error("No RCTI details found"));
            }
          }, dispatch);
        });
      }
      // Wait for both promises to resolve
      await Promise.all([itemsPromise, detailsPromise]);
    } catch (error) {
      console.error("Error in FetchQuotationDetailsByID:", error);
      // Handle errors as needed
    }

  }

  // const customStyles = {
  //   table: {
  //     style: {
  //       borderColor: tableBorder,
  //     },
  //   },
  //   headRow: {
  //     style: {
  //       color: darkMode ? "white" : "white",
  //       background: barColor,
  //       minHeight: '30px'
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       paddingLeft: "5px",
  //       paddingRight: "5px",
  //       fontSize: "12px",
  //       color: "white",
  //     },
  //   },
  // };

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }
  function calculateDueUpto(paymentTerms, rctiDate) {
    try {
      const currentDate = new Date(rctiDate);

      switch (paymentTerms) {
        case 'Same Day':
          return currentDate;
        case '7 Days':
          return addDays(currentDate, 7);

        case '14 Days':
          return addDays(currentDate, 14);

        case '30 Days':
          return addDays(currentDate, 30);

        case '14 Days End of Month':
          return addDays(endOfMonth(currentDate), 14);

        case '30 Days End of Month':
          return addDays(endOfMonth(currentDate), 30);

        default:
          throw new Error('Invalid payment term');
      }

    } catch (error) {
      console.error("calculateDueUpto Error", error);
    }

  }
  const handleValidUptoDate = (paymentTerms) => {
    try {
      const dueDate = calculateDueUpto(paymentTerms, values.rctiDate);
      setValues(prevValues => ({
        ...prevValues,
        dueDate: dueDate,
        dueUpto: paymentTerms,
      }));
    } catch (error) {
      console.error("handleValidUptoDate Error", error);
    }
  };


  const handleValidUpto = (name) => (event) => {
    if (name === 'dueUpto') {
      handleValidUptoDate(event.target.value);
    }
  }

  const handleChange = (name) => (event) => {
    let value = event?.target?.value;
    if (name === "gstType") {
      handleCalculation(value);
    } else if (name === "supplierID" && value === "add_new") {
      navigate("/contacts/addContact?new=rcti");
    }
    else if (event.target.validity && event.target.validity.valid) {
      setValues({ ...values, [name]: value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  }
  const handleChangeCustomer = (name) => (event, newValue) => {
    let value = event?.target?.value;


    console.log("sadasdasda", { [name]: newValue?.label, supplierID: newValue?.value })
    if (newValue) {
      if (newValue.value === 'add-new') {
        navigate("/contacts/addContact?new=rcti")
      } else {
        setValues({ ...values, [name]: newValue?.label, supplierID: newValue?.value });
      }
    }
    else {

      setValues({ ...values, [name]: '', supplierID: '' });
    }

  }

  const handleAddNewItem = async () => {
    // ShowSwalWithButtons(
    //   'Make sure to save your data', `Before adding an item. If you do not save the data, you will not get the  added item in the item field.`, 'warning', darkMode,
    //   async () => {
    //     await handleSaveRCTI('redirectToItemWhenSave');
    //     // navigate(`/addItems?new=rcti&id=${RCTI_ID}`)
    //   }
    // );
    await handleSaveRCTI('redirectToItemWhenSave');
  }
  const clearAllErrorMsg = () => {
    setContactNameErr(false);
    setInvoiceNoErr(false);
  }

  function identifyMissingItems(itemRowValues) {
    let missingItems = [];
    itemRowValues.forEach((row, index) => {
      if (!row.itemID || !row.itemPrice || !row.itemQuantity) {
        missingItems.push(index + 1);
      }
    });

    if (missingItems.length === 0) {
      return "All items are filled in.";
    }

    let missingItemsMessage = "Please fill in all of the following items before creating the rcti:\n";
    missingItems.forEach(itemIndex => {
      missingItemsMessage += `Row ${itemIndex}: `;
      if (!itemRowValues[itemIndex - 1].itemID) {
        missingItemsMessage += "Item Name, ";
      }
      if (!itemRowValues[itemIndex - 1].itemPrice) {
        missingItemsMessage += "Item Price, ";
      }
      if (!itemRowValues[itemIndex - 1].itemQuantity) {
        missingItemsMessage += "Item Quantity, ";
      }
      missingItemsMessage = missingItemsMessage.slice(0, -2);
      missingItemsMessage += "\n";
    });

    return missingItemsMessage;
  }

  //Handle Save or Update RCTI Function
  const handleSaveRCTI = async (redirectToOutside = null) => {

    type && (values.type = type);
    clearAllErrorMsg();
    let mandateFlag = false;
    let rctiDate = new Date(values.rctiDate);
    rctiDate.setUTCHours(0, 0, 0, 0);

    let dueDate = new Date(values.dueDate);
    dueDate.setUTCHours(23, 59, 59, 999);

    if (new Date(dueDate) < new Date(rctiDate)) {
      return showResMsg("Due date should be more than RCTI date.", 2000, false);
    }
    if (values.supplierID === "") {
      mandateFlag = validateField(values.supplierID, setContactNameErr) || mandateFlag;
      return
    }

    if (fieldsVisible) {
      mandateFlag = validateField(values.paymentMode, setPaymentModeErr) || mandateFlag;
      mandateFlag = validateField(values.paymentTransactionID, setPaymentTransactionIDErr) || mandateFlag;
      values.paymentAmount = values.finalAmount;
    } else {
      delete values.paymentMode;
      delete values.paymentTransactionID;
      delete values.paymentDate;
      delete values.paymentAmount;
    }

    if (RCTI_ID) {
      mandateFlag = validateField(values.rctiNumber, setInvoiceNoErr) || mandateFlag;

      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);

      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName && row.discountValue !== "");
        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else {
        if (redirectToOutside === 'redirectToItemWhenSave') {
          navigate(`/items/addItems?new=rcti&id=${RCTI_ID}`);
          return;
        } else {
          showResMsg("Please select at least 1 Item", 2000, false);
          return;
        }

        // navigate(`/items/addItems?new=rcti&id=${RCTI_ID}`);
        // return;
      }


    } else {
      const filterItemList = itemRowValues.filter(item => item.itemID !== "" && item.itemID !== null && item.itemID !== undefined);

      if (filterItemList.length > 0) {
        const allRowsFilled = filterItemList.every(row => row.itemID && row.itemPrice && row.itemQuantity && row.categoryCodeName);
        if (allRowsFilled) {
          values.itemsList = filterItemList;
        } else {
          return showResMsg(identifyMissingItems(filterItemList), 2000, false);
        }
      } else if (redirectToOutside === 'redirectToItemWhenSave') {

        sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
        navigate(`/items/addItems?new=rcti`);
        return;
      }
      if (redirectToOutside === 'redirectToEditItemWhenSave') {
        sessionStorage.setItem("HoldQuotationData", JSON.stringify(values));
        let ItemIdForItemEdit = sessionStorage.getItem("ItemIdForItemEdit")
        navigate(`/items/editItem/itemid=${ItemIdForItemEdit}?new=rcti`);
        return;
      }

      else {
        if (redirectToOutside === 'redirectToItemWhenSave') {
          // values.itemsList = [];
          console.log("redirectToOutside", redirectToOutside)
        } else {

          if (!values.itemsList || values.itemsList.length === 0) {
            showResMsg("Please select at least 1 Item", 2000, false);
            return;
          }
        }

        // showResMsg("Please select at least 1 Item", 2000, false);
        // return;
      }
    }
    if (mandateFlag) return
    values.currencyValue = currencyCode;

    handleApiResponse({
      isUpdate: RCTI_ID !== undefined,
      values,
      setOpen,
      showResMsg,
      navigate,
      handleSoftDismisal,
      setShowBillingModal,
      dispatch,
      redirectToOutside: redirectToOutside,
      RCTI_ID,
      // redirectToOutside: (RCTI_ID !== undefined),
    });


  }

  const handleCancelScreen = (index) => {
    ShowSwalWithButtons(
      'Are you sure?',
      `Would you like to exit from this ${RCTI_ID
        ? "Edit RCTI"
        : "Add New RCTI"
      }?`,
      'warning',
      darkMode,
      () => {
        let routePath = '/rcti'; // default
        navigate(routePath); // ✅ redirect user
      }
    );

  };
  const handleSoftDismisal = () => {
    ShowSwalWithButtons(
      `The Reference number already exists`,
      'Do you wish to continue?',
      'warning',
      darkMode,
      () => {
        values.skip_PO_NO = true;
        handleSaveRCTI();
      }
    );
  }


  //Handles Item Rows Functions
  const handleRemove = (index) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to remove the Item?`, 'warning', darkMode,
      () => {
        if (itemRowValues.length > 1) {
          const list = [...itemRowValues];
          list.splice(index, 1);
          setItemRowValues(list);
        } else {

          setItemRowValues([{
            itemName: "", itemID: "", itemPrice: "", itemQuantity: "", itemDescription: "", categoryCodeName: "", gst: "",
            discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: "",
          }])
        }
      }
    );
  };

  const addNewRowInList = (updatedRows) => {
    const emptyRowCount = updatedRows.filter(row => row.itemID === "" || row.itemID === undefined).length;
    if (emptyRowCount < 1) {
      setItemRowValues([
        ...updatedRows,
        {
          itemID: "", itemName: "", itemPrice: "", itemDescription: "", categoryCodeName: "", itemQuantity: "", gst: "",
          discountType: "None", discountValue: "", discountAmount: 0, totalItemPrice: "",
        }
      ]);
    }
  };

  const handleEdit = (id, index) => {
    sessionStorage.setItem("ItemIdForItemEdit", id);
    ShowSwalWithButtons(
      "Are you sure?",
      "Would you like to Edit the Item?",
      "warning",
      darkMode,
      async () => {
        await handleSaveRCTI('redirectToEditItemWhenSave');
        // navigate(`/items/editItem/${itemRowValues[index].itemID}?source=rcti&id=${RCTI_ID || ''}`);
      }
    );
  };

  const calculateDiscountAmount = (newItemRowValues) => {
    const updatedRows = newItemRowValues.map((item, idx) => {

      const itemPrice = parseFloat(item.itemPrice);
      const itemQuantity = parseFloat(item.itemQuantity);
      const discountValue = parseFloat(item.discountValue);
      let discountAmount = 0;

      const totalAmount = itemPrice * itemQuantity;
      if (item.discountType === "Percentage") {
        discountAmount = totalAmount * discountValue / 100;
      } else {
        discountAmount = discountValue;
      }
      return { ...item, discountAmount: parseFloat(discountAmount.toFixed(2)) || 0 };
    });
    setItemRowValues(updatedRows);
    handleCalculation(values.gstType);
  };
  const handleCalculation = (gstType) => {
    let TotalAmount = 0;
    let TotalDiscountAmount = 0;
    let TotalGSTAmount = 0;
    let FinalAmount = 0;

    itemRowValues.forEach(item => {
      let itemPrice = item.itemPrice || 0;
      let itemQuantity = item.itemQuantity || 0;
      let discount = item.discountAmount || 0;
      let gst = item.gst || 0;
      let itemTotalPrice = itemPrice * itemQuantity;
      let baseAmount = 0;
      let taxAmount = 0;




      if (["Inclusive", undefined].includes(gstType)) {
        const customerPayableAmount = itemTotalPrice;
        const Amount = calculatePrice(customerPayableAmount, gst, discount);
        baseAmount = Amount.itemActualPrice;
        taxAmount = Amount.taxAmount;
      } else {
        baseAmount = itemTotalPrice;
        taxAmount = gst * (itemTotalPrice - discount) / 100;
      }
      TotalAmount += baseAmount;
      TotalDiscountAmount += discount;
      TotalGSTAmount += taxAmount;

    });
    if (gstType === "Inclusive" || gstType === undefined) {
      FinalAmount = parseFloat(TotalAmount + TotalGSTAmount).toFixed(2);
    } else {
      FinalAmount = parseFloat((TotalAmount - TotalDiscountAmount) + TotalGSTAmount).toFixed(2);
    }
    setValues({
      ...values, gstType: gstType,
      totalAmount: parseFloat(TotalAmount).toFixed(2),
      totalDiscountAmount: parseFloat(TotalDiscountAmount).toFixed(2),
      totalGSTAmount: parseFloat(TotalGSTAmount).toFixed(2),
      finalAmount: parseFloat(FinalAmount).toFixed(2)
    });
  }
  const handleItemRowChange = async (name, value, index) => {
    console.log("TTT", name, value, index)
    const updatedRows = [...itemRowValues];
    // if (name === 'itemPrice' || name === 'itemQuantity') {
    if (value === '.') {
      value = '0.';
    }

    const regex = /^\d{1,7}(?:\.\d{0,2})?$/;

    if (regex.test(value) || value === "") {

      if (name === 'itemPrice' || name === 'itemQuantity') {
        if (parseFloat(value) === 0 || value === "") {
          showResMsg(`${await convertToTitleCase(name)} cannot be zero`, 1000, false)
        }
        updatedRows[index] = { ...updatedRows[index], [name]: value };
        updatedRows[index].totalItemPrice = parseFloat((updatedRows[index].itemPrice) * (updatedRows[index].itemQuantity)).toFixed(2);
        setItemRowValues(updatedRows);
      }
      else if (name === 'discountValue') {
        console.log("discountValue called")
        if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
          if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }

          if (value === "" || (parseFloat(value) < (parseFloat(itemRowValues[index].itemPrice) * parseFloat(itemRowValues[index].itemQuantity)) && itemRowValues[index].discountType === "Fixed")) {
            // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
            updatedRows[index] = {
              ...updatedRows[index],
              discountValue: value === "" ? "" : value,
            };
            setItemRowValues(updatedRows);
          }
        }
      }

    } else if (name === 'discountValue') {

      if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
        if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }

        if (value === "" || (parseFloat(value) < parseFloat(itemRowValues[index].itemPrice) && itemRowValues[index].discountType === "Fixed")) {
          // updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
          updatedRows[index] = {
            ...updatedRows[index],
            discountValue: value === "" ? "" : value,
          };
          setItemRowValues(updatedRows);
        }
      }
    } else if (name === "discountType" && value === "None") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountValue: 0, discountAmount: 0 };
      setItemRowValues(updatedRows);
    } else if (name === "discountType" && value === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: itemRowValues[index].discountValue };
      setItemRowValues(updatedRows);
    } else if (name === "discountType" && value === "Percentage") {

      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: itemRowValues[index].discountValue };
      setItemRowValues(updatedRows);
    } else if (name === "discountValue" && itemRowValues[index].discountType === "Fixed") {
      updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: value };
      setItemRowValues(updatedRows);
    } else {
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      setItemRowValues(updatedRows);
    }
  };

  // const handleItemRowChange = async (name, value, index) => {
  //   const updatedRows = [...itemRowValues];
  //   if (name === 'itemPrice' || name === 'discountValue' || name === 'itemQuantity') {
  //     if (value === '.') {
  //       value = '0.';
  //     }
  //     const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
  //     if (regex.test(value) || value === "") {
  //       if (name === 'itemPrice' || name === 'itemQuantity') {
  //         if (parseFloat(value) === 0 || value === "") {
  //           showResMsg(`${await convertToTitleCase(name)} cannot be zero`, 1000, false)
  //         }
  //         updatedRows[index] = { ...updatedRows[index], [name]: value };
  //         setItemRowValues(updatedRows);

  //       }
  //       else if (name === 'discountValue') {
  //         if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
  //           if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {

  //             updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
  //             setItemRowValues(updatedRows);
  //           }

  //           if (value === "" || (parseFloat(value) < (parseFloat(itemRowValues[index].itemPrice) * parseFloat(itemRowValues[index].itemQuantity)) && itemRowValues[index].discountType === "Fixed")) {
  //             updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
  //             setItemRowValues(updatedRows);
  //           }

  //         }
  //       }
  //     }
  //   }
  //   else if (name === "itemQuantity") {
  //     const regex = /^\d{1,7}$/;
  //     if (regex.test(value) || value === "") {
  //       updatedRows[index] = { ...updatedRows[index], [name]: parseInt(value) || 0, discountAmount: value === "" ? 0 : parseFloat(itemRowValues[index].discountValue) };
  //       setItemRowValues(updatedRows);
  //     }
  //   } else if (name === "discountType" && value === "None") {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountValue: 0, discountAmount: 0 };
  //     setItemRowValues(updatedRows);
  //   }
  //   else if ((name === "discountType" && value === "Fixed")) {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(itemRowValues[index].discountValue) };
  //     setItemRowValues(updatedRows);
  //   }
  //   else if (name === "discountValue" && itemRowValues[index].discountType === "Fixed") {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(value) };
  //     setItemRowValues(updatedRows);
  //   }
  //   else {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value };
  //     setItemRowValues(updatedRows);
  //   }
  // };

  // const handleItemRowChange = async (name, value, index) => {
  //   console.log(name, value, index)
  //   const updatedRows = [...itemRowValues];
  //   // if (name === 'itemPrice' || name === 'itemQuantity') {
  //   if (value === '.') {
  //     value = '0.';
  //   }
  //   const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
  //   if (regex.test(value) || value === "") {
  //     if (name === 'itemPrice' || name === 'itemQuantity') {
  //       if (parseFloat(value) === 0 || value === "") {
  //         showResMsg(`${await convertToTitleCase(name)} cannot be zero`, 1000, false)
  //       }
  //       updatedRows[index] = { ...updatedRows[index], [name]: value };
  //       updatedRows[index].totalItemPrice = parseFloat((updatedRows[index].itemPrice) * (updatedRows[index].itemQuantity)).toFixed(2);
  //       setItemRowValues(updatedRows);
  //     }

  //   } else if (name === 'discountValue') {
  //     if (itemRowValues[index].discountType === "Percentage" || itemRowValues[index].discountType === "Fixed") {
  //       if (value === "" || (parseFloat(value) < 100 && itemRowValues[index].discountType === "Percentage")) {
  //         updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
  //         setItemRowValues(updatedRows);
  //       }

  //       if (value === "" || (parseFloat(value) < parseFloat(itemRowValues[index].itemPrice) && itemRowValues[index].discountType === "Fixed")) {
  //         updatedRows[index] = { ...updatedRows[index], [name]: value || 0 };
  //         setItemRowValues(updatedRows);
  //       }
  //     }
  //   } else if (name === "discountType" && value === "None") {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountValue: 0, discountAmount: 0 };
  //     setItemRowValues(updatedRows);
  //   } else if (name === "discountType" && value === "Fixed") {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(itemRowValues[index].discountValue) };
  //     setItemRowValues(updatedRows);
  //   } else if (name === "discountValue" && itemRowValues[index].discountType === "Fixed") {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value, discountAmount: parseFloat(value) };
  //     setItemRowValues(updatedRows);
  //   } else {
  //     updatedRows[index] = { ...updatedRows[index], [name]: value };
  //     setItemRowValues(updatedRows);
  //   }
  // };

  const handleItemDescription = async (name, value, index) => {
    const updatedRows = [...itemRowValues];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setItemRowValues(updatedRows);
  };

  const handleItemRow = async (name, newValue, index) => {
    if (!newValue) {
      showResMsg("Please select an item", 1000, false);
    }
    if (newValue.value === 'add-new') {
      handleAddNewItem();
    } else {
      const selectedItem = masterItemDetails.find(item => item._id === newValue.value);
      if (selectedItem) {
        const updatedRows = [...itemRowValues];
        updatedRows[index] = {
          ...updatedRows[index],
          itemID: newValue.value,
          // itemDescription: selectedItem.itemDescription,
          itemDescription: selectedItem.itemDescription ? selectedItem.itemDescription : selectedItem.itemName,
          categoryCodeName: selectedItem.categoryCodeName,
          itemName: selectedItem.itemName,
          itemPrice: parseFloat(selectedItem.itemPrice),
          itemQuantity: parseFloat(selectedItem.itemQuantity),
          totalItemPrice: (parseFloat(selectedItem.itemPrice).toFixed(2)) * (parseFloat(selectedItem.itemQuantity).toFixed(2)),
          gst: parseFloat(selectedItem.gst),
          discountType: selectedItem.discountType,
          discountValue: selectedItem.discountValue,
          discountAmount: selectedItem.discountType === "Fixed" ? selectedItem.discountValue : 0,
        };
        setItemRowValues(updatedRows);
        handleCalculation(values.gstType);
      }
    }
  };

  useEffect(() => {
    const itemFromUrl = new URLSearchParams(window.location.search).get('item');

    console.log("itemFormUrl", itemFromUrl)
    if (itemFromUrl) {

      const selectedItem = masterItemDetails.find(item => item._id === itemFromUrl);
      console.log("selectedItem", selectedItem)
      console.log("itemRowValues", itemRowValues)
      const alreadyItemAdded = itemRowValues.some(
        item => item.itemID === itemFromUrl
      );
      console.log("alreadyItemAdded", alreadyItemAdded)
      // if (alreadyItemAdded) {

      //   console.log("Item already exists, skipping...");
      //   return;
      // }
      if (selectedItem) {

        console.log("selectedItem", selectedItem)
        const newItemValue = { value: itemFromUrl };

        // Find the first empty row (if any)
        const emptyRowIndex = itemRowValues.findIndex(row => !row.value);

        if (emptyRowIndex) {
          // Update the first empty row found
          handleItemRow('', newItemValue, emptyRowIndex);
        } else {
          // If no empty row is found, update the last row or add new row logic
          const lastIndex = itemRowValues.length - 1;
          handleItemRow('', newItemValue, lastIndex);

          console.warn('No empty row found, updating the last row instead');
        }
      }

    }
  }, [masterItemDetails]);

  const filteredOptions = itemsDetails.map(item => ({
    label: item.itemName,
    value: item._id,
  }));

  const coloredShadowChange = document.querySelectorAll(".dayHour");
  if (coloredShadowChange) {
    for (let i = 0; i < coloredShadowChange.length; i++) {
      coloredShadowChange[i].style.color = darkMode ? "white" : "black";
    }
  }

  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Item Name</p>,
      selector: (row, i) => (
        <Autocomplete
          disableClearable
          key={`${i}-${row.itemID}`}
          id={`item-${i}`}
          sx={{
            '& .MuiInputBase-root': {
              width: "170px",
              marginTop: "4px"
            },
            "& .MuiInput-root": {
              height: "35.11px",
              color: " #000000",
              fontFamily: "Roboto",
              "&:before": {
                borderColor: darkMode ? "white" : tableBorder,

              },
              "&:after": {
                borderColor: darkMode ? tableBorder : tableBorder,
              },
            },
          }}

          options={[{ label: "Add New Item", value: "add-new" }, ...filteredOptions]}
          onChange={(event, newValue) => handleItemRow("itemID", newValue, i)}
          value={row.itemName}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) =>
            <TextField {...params}
              autoFocus
              variant="standard"
              placeholder="Search for a Item"
              size="medium"
              style={{ height: "35.11px", }}
              inputProps={{
                ...params.inputProps,
                maxLength: 200,   // ⭐ Max length applied
              }}
            />
          }
          renderOption={(props, option) => {
            // const customStyle = option.value === 'add-new' ? 'dropDownDefaultHighlight' : darkMode ? 'autoCompleteDarkList' : 'autoCompleteList';
            const customStyle = option.value === 'add-new'
              ? (darkMode ? tableBorder : tableBorder)
              : (darkMode ? 'autoCompleteDarkList' : 'autoCompleteList');
            return (
              <li
                {...props}
                key={option.value}
                style={{ fontSize: '12px', color: darkMode ? tableBorder : tableBorder, padding: "4.8px 16px", fontWeight: "bold", fontFamily: "Roboto, Helvetica, Arial, sans-serif", cursor: 'pointer' }}
                className={customStyle}
              >
                {option.label}
              </li>)
          }}

          filterOptions={(options, state) => {
            const filtered = options.filter(option => option.label.toLowerCase().includes(state.inputValue.toLowerCase()));
            if (!filtered.some(option => option.value === 'add-new')) {
              filtered.unshift({ label: "Add New Item", value: "add-new" });
            }
            return filtered;
          }}
        />
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '170px',


    },
    {
      name: <p style={{ fontSize: "12px" }}>Description</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              value={row.itemDescription}
              onChange={(event) => handleItemDescription("itemDescription", event.target.value, i)}
              autoComplete="off"
              className="removeExtraPadding"
              id="standard-textarea"
              placeholder="Description"
              multiline
              variant="standard"
              sx={{
                '& .MuiInputBase-root': {
                  width: "320px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              InputProps={{
                style: {
                  fontSize: '12px',
                  whiteSpace: 'pre-wrap',
                  overflowWrap: 'break-word',
                  width: "100%",
                  minWidth: '300px',
                  color: darkMode ? "white" : "black",
                  boxSizing: 'border-box',
                  display: 'block',
                },
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '260px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Qty</p>,
      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              type="text"
              className="removeExtraPadding"
              fullWidth
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              sx={{
                '& .MuiInputBase-root': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              variant="standard"
              value={row.itemQuantity}
              onChange={(event) => handleItemRowChange("itemQuantity", event.target.value, i)}
              inputProps={{
                maxLength: 5,
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Item Price</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.itemPrice)}
              variant="standard"
              onChange={(event) => handleItemRowChange("itemPrice", event.target.value, i)}
              onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, "")}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Amount</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              value={formatCurrencyAUD(row.totalItemPrice)}
              variant="standard"
              disabled
              // onChange={(event) => handleItemRowChange("totalItemPrice", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,
                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
              inputProps={{
                maxLength: 8,
                pattern: "[]",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Account</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              disabled
              type="text"
              value={row.categoryCodeName}
              variant="standard"
              onChange={(event) => handleItemRowChange("categoryCodeName", event.target.value, i)}
              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              autoComplete="off"
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '200px',
    },

    {
      name: <p style={{ fontSize: "12px" }}>GST (%)</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"
              fullWidth

              sx={{
                '& .MuiInputBase-input ': {
                  marginTop: "4px",
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              value={row.gst}
              onChange={(event) => handleItemRowChange("gst", event.target.value, i)}
              disabled
              style={{ cursor: 'default', pointerEvents: 'none' }}

            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Type</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="standard" sx={{ m: 1, mt: 0, ml: -1.5 }}>
              <Select
                style={{ height: "35.11px", marginTop: "1.5px" }}
                labelId="day-hours-select-label"
                id="day-hours-select"
                className="dayHour"
                value={row.discountType}
                onChange={(event) => handleItemRowChange("discountType", event.target.value, i)}
                fullWidth
                sx={{
                  width: "100px"
                  ,
                  color: darkMode ? "white" : "black",
                  '& .MuiInputBase-input ': {
                  },
                  '&:before': {
                    borderBottomColor: darkMode ? "white" : tableBorder,
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    borderBottomColor: darkMode ? "white" : tableBorder
                  },
                  '&:after': {
                    borderBottomColor: darkMode ? tableBorder : tableBorder,
                  },
                  '& .MuiSelect-select': {
                    color: darkMode ? "white" : "black",
                  },
                }}
                variant="standard"
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Fixed">Fixed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
      width: '140px',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Discount Value</p>,

      selector: (row, i) => (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              type="text"
              autoComplete="off"
              variant="standard"

              fullWidth
              sx={{
                '& .MuiInputBase-input ': {
                  textAlign: "left",
                  marginTop: "4px"
                },
                "& .MuiInput-root": {

                  color: " #000000",
                  fontFamily: "Roboto",
                  "&:before": {
                    borderColor: darkMode ? "white" : tableBorder,

                  },
                  "&:after": {
                    borderColor: darkMode ? tableBorder : tableBorder,
                  },
                },
              }}
              disabled={row.discountType === "None"}
              value={row.discountType === "None" ? 0 : row.discountValue ?? ""}
              // value={row.discountType === "None" ? 0 : row.discountValue}
              onChange={(event) => handleItemRowChange("discountValue", event.target.value, i)}
              inputProps={{
                maxLength: 30,
                pattern: "^[a-zA-Z0-9 ]+$",
              }}
            />
          </Grid>
        </Grid>
      ),
      style: {
        justifyContent: 'flex-start',
      },
    },

    {
      // name: "Action",
      name: <p></p>,
      selector: (row) => row._id,
      cell: (row, i) => (
        <>
          <Grid container style={{ display: "flex", justifyContent: "center" }} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              {/* {row.itemID ?
                <TimelineItem
                  color="error"
                  icon="delete"
                  onClick={() => {
                    handleRemove(i);
                  }}
                  title="Delete"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="delete"
                  title="Delete"
                />
              } */}
              {
                row.itemID &&
                  (
                    RCTI_ID === undefined || itemRowValues.length > 2
                  ) ? (
                  <TimelineItem
                    color="error"
                    icon="delete"
                    onClick={() => {
                      handleRemove(i, row.itemID);
                    }}
                    title="Delete"
                  />
                ) : (
                  <TimelineItem
                    color="gray"
                    icon="delete"
                    title="Delete"
                  />
                )
              }
            </Grid>
            <Grid item>
              {row.itemID ?
                <TimelineItem
                  color="success"
                  icon="edit"
                  onClick={() => {
                    handleEdit(row.itemID, i);
                  }}
                  title="Edit"
                />
                :
                <TimelineItem
                  color="gray"
                  icon="edit"
                  title="Edit"
                />
              }

            </Grid>
          </Grid>
        </>
      ),



    },
  ];

  //RCTI Document Functions

  const saveFile = async (event) => {
    const file = event.target.files[0];
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
    // console.log("fileName", fileNameWithoutExtension);
    setValues((prev) => ({
      ...prev,
      documentName: fileNameWithoutExtension,
    }));
    if (file && file.type) {

      if (file.size > 1 * 1024 * 1024) {
        setFileError('File size should be less than 1 MB');
        return;
      } else {
        setFileError('');
        document.getElementById("rctiDocuments").value = file.name;
        if (file.name) {
          try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("rctiID", values.rctiID);
            formData.append("documentName", fileNameWithoutExtension);
            formData.append("fileType", await getFileType(file.type));
            values.selectedID && formData.append("documentID", values.selectedID);
            setLoading(true);

            await axios.post(appConstants.baseURL + "invoice/uploadRCTIDocument", formData, {
              headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }
            }).then(res => {
              let response = res.data;
              setLoading(false);
              showResMsg(response.Result_Message, 2000, response.Result_Status);
              if (response.Result_Status) {
                // setShowItemAndDocumentSection(true);
                setValues({ ...values, documentName: "", selectedID: "" });
                setDocuments(response.Result_Output);
                document.getElementById("rctiDocuments").value = "";
              }
            })

          } catch (error) {
            console.log("error addDocument", error);
          }
        }
        else {

          setFileError('Please enter Document Name');
        }
      }
    } else {
      console.log('No file selected or file object is false/undefined');
      showResMsg('Please select a valid file!', 2000, false);
      setFileError('');
    }
  };

  const handleEditDocument = (selectedDocRow) => {
    swal({
      title: "Are you sure?",
      text: `Would you like to edit "${selectedDocRow.documentName}" file?`,
      icon: "warning",
      color: 'red',
      customClass: "swal-modal swal-title",
      closeOnClickOutside: false, closeOnEsc: false, buttons: {
        cancel: {
          text: "No", value: false, visible: true, className: "swalButtonStyle btn-warning", closeModal: true,
        },
        confirm: {
          text: "Yes", value: true, visible: true, className: "swalButtonStyle btn-success", closeModal: true
        }
      }
    }).then(async (value) => {
      if (value) {
        setValues({ ...values, documentName: selectedDocRow.documentName, selectedID: selectedDocRow._id });
      }
    });

  }

  const handleDeleteDocument = async (selectedDocRow) => {
    swal({
      title: "Are you sure?",
      text: `Would you like to delete "${selectedDocRow.documentName}" file?`,
      icon: "warning",
      color: 'red',
      customClass: "swal-modal swal-title",
      closeOnClickOutside: false, closeOnEsc: false, buttons: {
        cancel: {
          text: "No", value: false, visible: true, className: "swalButtonStyle btn-warning no-button", closeModal: true,
        },
        confirm: {
          text: "Yes", value: true, visible: true, className: "swalButtonStyle btn-success yes-button", closeModal: true
        }
      }
    }).then(async (value) => {
      if (value) {
        await axios.post(appConstants.baseURL + "invoice/deleteRCTIDocument", { documentID: selectedDocRow._id }, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` }
        }).then(
          res => {
            showResMsg(res.data.Result_Status ? "Document deleted successfully" : res.data.Result_Message, 2000, res.data.Result_Status);
            if (res.data.Result_Status) {
              const updatedQuoDocument = quoDocuments.filter(doc => {
                return doc.documentName !== selectedDocRow.documentName;
              });
              setDocuments(updatedQuoDocument);
            }
          }).catch(error => {
            console.log("delete RCTI_Document error", error.message);
          })
      }
    });
  }
  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            {/* {(RCTI_ID) &&
              <Grid item>
                <TimelineItem color="success" icon="edit" title="Edit"
                  onClick={() => { handleEditDocument(row) }}
                />

              </Grid>} */}

            <Grid item>
              {row.fileType === "docx" || row.fileType === "doc" || row.fileType === "excel" ?
                <a className="testing" href={appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + row.documentFileName} download target="_blank" rel="noopener noreferrer">
                  <TimelineItem
                    color="info"
                    icon="visibility"
                    onClick={() => { renderFilePreview(row) }}
                    title="View"
                  // disabled={SCREEN_RIGHT === "View Only"}
                  /></a> : <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => { handleViewDocument(row) }}
                  title="View"
                // disabled={SCREEN_RIGHT === "View Only"}
                />}

            </Grid>
            {/* 
            <Grid item>
              <TimelineItem
                color="info"
                icon="visibility"
                onClick={() => { handleViewDocument(row) }}
                title="View"
              />
            </Grid> */}
            {(RCTI_ID) && <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDocument(row)}
                title="Delete"
                disabled={SCREEN_RIGHT === "View Only"}
              />
            </Grid>}
          </Grid>
        </>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: false,
  };

  const handleDateChange = (date) => {

    values.rctiDate = new Date(date)

    setValues({ ...values, rctiDate: values.rctiDate })
  };
  const handleDueDateChange = async (date) => {
    setValues({ ...values, dueDate: new Date(date) });
  };


  const toggleFields = () => {
    if (fieldsVisible) {
      swal({
        title: "Would you like to Hide Payment Details?",
        text: `Hide Payment Details will not update the payment details.`,
        icon: "warning",
        color: 'success',
        customClass: "swal-modal swal-title",
        closeOnClickOutside: false, closeOnEsc: false, buttons: {
          cancel: {
            text: "No", value: false, visible: true, className: "swalButtonStyle btn-warning no-button", closeModal: true,
          },
          confirm: {
            text: "Yes", value: true, visible: true, className: "swalButtonStyle btn-success yes-button", closeModal: true
          }
        }
      }).then(async (value) => {
        if (value) {
          setFieldsVisible(!fieldsVisible);
        }
        swal.close();
      });
    } else {
      setFieldsVisible(!fieldsVisible)
    }
  }

  const handleSaveAndSendToEmail = async () => {

    if (itemRowValues.every(row => !row.itemID)) {

      Swal.fire({
        title: 'Warning',
        text: "Please select the Item(s) before sending the email.",
        icon: 'warning',
        confirmButtonText: 'OK'
      });
    } else {
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to send the RCTI (${values.rctiNumber}) via email to the Supplier Email Address?`, 'question', darkMode,
        () => {
          values.sendEmailFlag = true;
          handleSaveRCTI();
        }
      );
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: `Would you like to send the RCTI (${values.rctiNumber}) via email to the Supplier Email Address?`,
      //   icon: "question",
      //   showCancelButton: true,
      //   confirmButtonColor: "#4CAF50",
      //   cancelButtonColor: "#6c757d",
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "No",
      //   reverseButtons: "true",
      //   reverseButtons: true,
      //   customClass: {
      //     title: darkMode ? 'swal-title-dark' : 'swal-title-light',
      //     popup: darkMode ? "darkPopup" : "whitePopup",
      //   }
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     values.sendEmailFlag = true;
      //     handleSaveRCTI();
      //   }
      // });
    }


  }




  const handleViewDocument = (selectedDocRow) => {
    setSelectedFileType(selectedDocRow.fileType);
    if (selectedDocRow.fileType === "pdf" || selectedDocRow.fileType === "image") {
      const path = appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName;
      setSetDocumentFileURL(path);
      path && setViewDocumentInModal(true);
    } else {
      showResMsg("Document type not supported.", 2000, false)
    }

  };
  const renderFilePreview = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
  }
  const handleCloseViewModal = () => {
    setSetDocumentFileURL('');
    setSelectedFileType('');
    setViewDocumentInModal(false);
  }
  //Modal Email Template used fxn start
  const handleEmailQuotation = async () => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: values.supplierID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        if (data.Result_Status) {
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg("Please try again! Something went wrong");
          setOpen(false);
        }
      }, dispatch);
    }
  }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {
    let payload = {
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    values.sendEmailFlag = true;
    values.templateValues = payload;
    // return console.log(values.templateValues);
    handleSaveRCTI();
  }


  // const handleRoute = () => {
  //   const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
  //   if (contactFromUrl) {
  //     navigate(`/contacts/editContact/${contactFromUrl}`);
  //   }
  //   setOpenPop(false)
  // }

  // const handleRouteCancel = () => {
  //   setOpenPop(false)
  // }
  //Modal Email Template used fxn ends
  useEffect(() => {
    const contactFromUrl = new URLSearchParams(window.location.search).get('contact');
    console.log("contactFromUrl", contactFromUrl)
    if (contactFromUrl) {
      if (contactFromUrl === 'add-new') {
        console.log("add-new")
        handleChangeCustomer('name')('', { label: 'Add New ', value: 'add-new' });
      } else {
        const selectedContact = contactDetails.find(contact => contact._id === contactFromUrl);
        console.log("selectedContact", selectedContact)
        if (selectedContact) {
          handleChangeCustomer('name')('', { label: selectedContact.companyName, value: contactFromUrl });
        }
        // else {
        //   setOpenPop(true)
        // }
      }
    }
  }, [contactDetails]);

  const supplierOptions = [
    ...(showAddNewSupplier ? [{ label: 'Add New Supplier', value: 'add-new' }] : []),
    ...contactDetails.map(contact => ({
      label: contact.companyName,
      value: contact._id
    }))
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container px={2} mt={2} spacing={2}>

            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={4}>
              <Autocomplete
                id="customerName-select"
                options={supplierOptions}
                // options={[
                //   { label: 'Add New ', value: 'add-new' },
                //   ...contactDetails.map(contact => ({ label: contact.companyName, value: contact._id }))
                // ]}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option?.value}
                    className={
                      darkMode ?
                        `${option?.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteDarkList'}` :
                        `${option?.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}`
                    }
                  >
                    {option.label}
                  </li>
                )}
                filterOptions={(options, state) => {
                  const filtered = options.filter(option =>
                    option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                  );

                  if (
                    showAddNewSupplier
                    &&
                    !filtered.some(option => option.value === 'add-new')
                  ) {
                    filtered.unshift({ label: 'Add New Supplier', value: 'add-new' });
                  }

                  return filtered;
                }}
                // filterOptions={(options, state) => {
                //   const filtered = options.filter(option =>
                //     option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                //   );
                //   if (!filtered?.some(option => option?.value === 'add-new')) {
                //     filtered?.unshift({ label: 'Add New ', value: 'add-new' });
                //   }
                //   return filtered;
                // }}
                onChange={handleChangeCustomer("name")}
                isOptionEqualToValue={(option, value) => {
                  if (value === "") {
                    return true;
                  }
                  return option.label === value;
                }}
                value={
                  (values?.supplierID && contactDetails.find(contact => contact?._id === values?.supplierID)?.companyName) ||
                  (new URLSearchParams(window.location.search).get('contact') === 'add-new' ? 'Add New ' : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Supplier"
                    autoFocus={true}
                    placeholder="Enter Supplier Name"
                  />
                )}
              // disabled={values?.invoiceType === "Through Quotation" || RCTI_ID}
              />

              {contactNameErr ? <p style={errMsg}>Please Select Supplier</p> : ""}
            </Grid>

            <Grid item lg={3} xs={6} >
              <PickDate
                selected={new Date(values?.rctiDate)}
                onChange={handleDateChange}
                label="RCTI Date"
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                minDate={new Date()} />
            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Due Upto</InputLabel>
                <Select
                  labelId="dueUpto-label"
                  label="Due Upto"
                  style={{ height: "35px" }}
                  onChange={handleValidUpto("dueUpto")}
                  value={values.dueUpto}
                  displayEmpty
                >
                  <MenuItem disabled value="">Select Due Upto</MenuItem>
                  {paymentTermsOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>{option}</MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Grid>
            <Grid item lg={3} xs={12}>
              <PickDate
                selected={new Date(values.dueDate)}
                onChange={handleDueDateChange}
                label="Due Date"
                minDate={new Date(values?.rctiDate)}
              />
            </Grid>

            {/* RCTI Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="RCTI Number"
                variant="outlined"
                disabled
                fullWidth
                inputProps={{
                  maxLength: 12,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                value={values?.rctiNumber}

              />
              {invoiceNoErr ? <p style={errMsg}>RCTI Number can't be blank.</p> : ""}
            </Grid>

            {/* Reference Number */}
            <Grid item lg={1.5} xs={3}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                inputProps={{
                  maxLength: 50,
                  pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                  className: "custom-fieldtext"

                }}

                value={values?.purchaseOrderNumber}
                onChange={handleChange('purchaseOrderNumber')}

              />
            </Grid>
            <Grid item lg={1.5} xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.recurring || false}
                    onChange={(e) => handleChange("recurring")({ target: { value: e.target.checked } })}

                  />
                }
                label="Recurring"
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.4px" }}
                  label="Status"
                  value={values?.rctiStatus}
                  disabled
                  onChange={handleChange('rctiStatus')}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>


          {/* {(!RCTI_ID) &&
              <Grid item px={2} pt={1} xs={12} md={4} lg={12} >
                <p style={{ fontSize: "14px", fontWeight: "bold", color: "#00FFBC" }} >Items</p>
              </Grid>
            } */}
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}
            />
          </CardContent>

          <Grid container px={2} style={{ marginTop: '10px' }} spacing={2}>

            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Base Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values?.totalAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total Discount  (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values?.totalDiscountAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values?.gstType || 'Inclusive'}
                  onChange={handleChange('gstType')}
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={2} xs={6}>
              <TextField
                type="text"
                label={`Total GST  (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(values?.totalGSTAmount)}
                autoFocus={true}
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label={`Final Amount (${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 30,
                  pattern: "^[a-zA-Z0-9 ]+$",
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={formatCurrencyAUD(parseFloat(values?.finalAmount).toFixed(2))}
              // autoFocus={true}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                inputProps={{
                  maxLength: 100,
                  className: "custom-fieldtext"
                }}
                value={values?.paymentInstruction}
                onChange={handleChange('paymentInstruction')}
              // autoFocus={true}
              />
            </Grid>
          </Grid>

          {RCTI_ID &&
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={4} lg={12}>
                <Button onClick={() => setExpanded(!expanded)} >
                  <Badge badgeContent={quoDocuments.length} sx={{ ".MuiBadge-badge": { backgroundColor: tableBorder, color: "#ffffff" }, }} color="info" showZero>
                    <Typography variant="h6" sx={{ border: darkMode ? "1px solid white" : `1px solid ${tableBorder}`, borderRadius: "5px", color: darkMode ? "white" : tableBorder, display: 'flex', alignItems: 'center', marginLeft: "-9px", padding: "1px 10px", fontSize: "12px" }}>
                      Attached Document
                      {expanded ? <ArrowDropDown className="arrowdropdown" style={{ marginLeft: "5px", }} /> : <ArrowDropUpIcon className="arrowdropdown" style={{ marginLeft: "5px", }} />}
                    </Typography>
                  </Badge>
                </Button>
              </Grid>
            </Grid>
          }


          {expanded && <>
            {RCTI_ID &&
              <>
                <Grid container spacing={2} px={2} pt={2}>

                  <Grid item xs={12} lg={3.7}>
                    <label htmlFor="fileInput">
                      <TextField
                        id="rctiDocuments"
                        type="text"
                        label="Document File"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          readOnly: true,
                          className: "uploadfile",
                          startAdornment: (
                            <InputAdornment position="start">
                              <label className="ress" htmlFor="fileInput">
                                <Button component="span" size="small" style={{ fontSize: "14px", marginTop: "4px", marginLeft: "-19px", color: `${darkMode ? "white" : tableBorder}`, textDecoration: "2px solid underline" }}
                                // onClick={() => { !values.documentName && (showResMsg("Please enter document name", 2000, false)) }}
                                >Choose File</Button>
                              </label>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <input
                        type="file"
                        // accept="image/*,.pdf,.docx,.doc,application/vnd.ms-excel,text/csv"
                        id="fileInput"
                        style={{ display: "none" }}
                        // disabled={!values.documentName}
                        onChange={saveFile}
                      />
                    </label>
                    <p style={errMsg}>{fileError}</p>
                  </Grid>
                </Grid>
              </>}
            {quoDocuments.length > 0 && <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>}
          </>
          }


          {RCTI_ID &&
            <Grid container px={2} pt={2} spacing={2}>
              {showInvoicePaymentLink &&
                <Grid item xs={12} md={4} lg={12}>
                  <Typography
                    variant="button"
                    fontWeight="bold"
                    onClick={toggleFields}
                    color={fieldsVisible ? "error" : tableBorder}
                    sx={{ cursor: "pointer", userSelect: "none", textDecoration: 'underline' }}
                    className={darkMode ? tableBorder : "darktext"}
                  >
                    {(values?.rctiStatus === "Paid") ? "Click to View Payment Details" : fieldsVisible ? "Click to Hide Payment Details" : "Click to Update Payment Details"}
                  </Typography>
                </Grid>}

              {fieldsVisible && <>
                <Grid item lg={3} xs={6} >
                  <TextField
                    type="text"
                    label="Payment Date"
                    variant="outlined"
                    placeholder="Payment Date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={format(new Date(values?.paymentDate), 'MMM dd, yyyy')}

                    inputProps={{
                      className: "custom-fieldtext"
                    }}
                  />
                </Grid>
                <Grid item lg={3} xs={6}>

                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Payment Mode</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "35.11px" }}
                      label="Payment Mode"
                      onChange={handleChange("paymentMode")}
                      value={values?.paymentMode}
                    >
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Paypal">Paypal</MenuItem>
                      <MenuItem value="Card">Card</MenuItem>
                      <MenuItem value="Cheque">Cheque</MenuItem>
                      <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                      <MenuItem value="Wire Transfer">Wire Transfer</MenuItem>
                    </Select>
                  </FormControl>
                  {paymentModeErr ? <p style={errMsg}>Payment Mode can't be blank.</p> : ""}
                </Grid>
                <Grid item lg={3} xs={6}>
                  <TextField
                    type="text"
                    label="Transaction ID"
                    variant="outlined"
                    placeholder="Transaction ID"
                    autoComplete="off"
                    inputProps={{
                      className: "custom-fieldtext"
                    }}
                    fullWidth
                    value={values?.paymentTransactionID}
                    onChange={handleChange('paymentTransactionID')}

                  />
                  {paymentTransactionIDErr ? <p style={errMsg}>Transaction ID can't be blank.</p> : ""}
                </Grid>
                <Grid item lg={3} xs={6}>
                  <TextField
                    type="text"
                    label={`Payment Amount (${currencyCode})`}
                    variant="outlined"
                    placeholder={`Payment Amount (${currencyCode})`}
                    inputProps={{
                      className: "custom-fieldtext"
                    }}
                    fullWidth
                    disabled
                    value={`${formatCurrencyAUD(parseFloat(values?.finalAmount).toFixed(2))}`}
                  />
                </Grid>
              </>}
            </Grid>}

          <Grid
            container
            mt={2}
            pb={3}
            // columnSpacing={4}
            alignItems="center"
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
            className="gridbuttons"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.718}>
              {/* <Link to={"/rcti"}> */}
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ height: "40px" }}
                onClick={handleCancelScreen}
              >
                Close
              </MDButton>
              {/* </Link> */}
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.718}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                onClick={handleSaveRCTI}
              // disabled={SCREEN_RIGHT !== "Full Access"}
              >
                {/* {RCTI_ID ? (type !== "clone" ? "Save" : "Clone ") : "Save"} */}
                {RCTI_ID ? (type !== "clone" ? "Update" : "Clone ") : "Save"}

              </MDButton>
            </Grid>
            {RCTI_ID &&
              <Grid item xs={12} md={4} spacing={2} lg={1.718} style={{ cursor: `${showSendEmailBtn ? "pointer" : "not-allowed"}` }}>
                <MDButton
                  rel="noreferrer"
                  variant="gradient"
                  color="info"
                  fullWidth
                  disabled={!showSendEmailBtn}
                  // onClick={handleSaveAndSendToEmail}
                  onClick={handleEmailQuotation}
                  style={{ height: "40px" }}
                // disabled={SCREEN_RIGHT !== "Full Access"}
                >
                  Send Email
                </MDButton>
              </Grid>}
          </Grid>

        </Card>
      </div>

      {
        viewDocumentInModal && <Modal
          open={viewDocumentInModal}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            '& .MuiModal-root': {
              width: '100%',
              height: '100%',
            },
          }}
        >
          <Card
            sx={darkMode ?
              { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px", background: "black" } :
              { ...pdfStyle, border: "none", width: { xs: "95%", sm: "90%", md: "80%" }, maxWidth: "1200px" }
            }
          >
            <Box>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
              >
                Document Viewer
              </Typography>
              <Box sx={{ width: "100%", height: { xs: "60vh", sm: "70vh" }, overflow: "hidden" }}>
                {selectedFileType === "image" ? (
                  <img
                    title="Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="100%"
                    style={{ display: 'block', objectFit: "contain", aspectRatio: "1/1" }}
                    alt="Document Viewer"
                  />
                ) : selectedFileType === "pdf" ? (
                  <iframe
                    title="Quotation Document Viewer"
                    src={getDocumentFileURL}
                    width="100%"
                    height="650"
                    allowFullScreen
                  ></iframe>
                ) : null}
              </Box>
              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <MDButton
                  color="warning"
                  className="modalButton"
                  onClick={() => { setViewDocumentInModal(false) }}
                  sx={{ fontSize: "1rem", padding: "0.5rem 1rem" }}
                >
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      }
      {
        showBillingModal && <BillingModal
          open={showBillingModal}
          handleConfirm={() => { navigate('/subscriptions') }}
          handleCancel={() => { setShowBillingModal(false) }}
          closeModalClick={() => { setShowBillingModal(false) }}
          message={genericMessage.billingMsg}
          title={genericMessage.noCreditAvailableTitle}
        />
      }
      {
        open && <EmailTemplateModal
          open={open}
          handleClose={handleClose}
          templatesData={templateValues}
          onSend={handleSend}
        />
      }

      {/* {openPop && (
        <RouteModal
          open={openPop}
          handleRoute={handleRoute}
          handleCancel={() => handleRouteCancel("handleRouteCancel")}
          closeModalClick={() => handleRouteCancel("closeModalClick")}
          heading={"Please Send the Email for Verify the Supplier by Editing"}
        />
      )} */}
      <LoadingModal loading={loading} />

    </DashboardLayout >
  );
}

export default RCTI;
